module.exports = __webpack_public_path__ + "img/nfs.72f10521.svg";